import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { Get } from '../../utils/httpProvider';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-js-pagination';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';


import {
    nhiemVuKhacPagingAction,
    deleteNhiemVuKhacAction,
    filterListNhiemVuKhac,
    nhiemVuKhacGetFilesAction
} from '@store/reducers/nhiemvukhac';
import { nhanVienGetAllAction } from '@store/reducers/nhanVien';
import { getNguoiDungByAccountId, getNguoiDungById } from '@store/reducers/nguoidung';

import { createUrlWithParam } from '../../utils/helper';
import { URI_INTERNAL } from '../../utils/pathLocations';
import { objectShowNumber, messageToast } from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import {
    mapTrangThaiKhacLabel,
    mapMucDoUuTienLabel,
    TRANG_THAI_KHAC_OPTIONS,
    MUC_DO_UU_TIEN
} from '@app/store/constants';

// filter UI
import Select from 'react-select';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import * as moment from 'moment';

// file view/download
import { BaseGatewayImage } from '@app/utils/apiUrl';
import { NHIEMVUKHAC_API, NGUOIDUNG_API } from '../../utils/apiUrl';
import { downloadFileByUrls } from '@app/utils/fileDownload';
import { Dropdown } from 'react-bootstrap';
import { userManager } from '@app/utils/oidc';
import { getInfomationAccountFromToken } from '../../utils/helper';


// Style trạng thái
const STATUS_COLOR_MAP_KHAC = {
    chuabatdau: { bg: '#e1e5f2', text: '#333333', border: '#c4ccdd' },
    dangthuchien: { bg: '#d3e5ff', text: '#245b8f', border: '#aac6ff' },
    hoanthanh: { bg: '#cef4e4', text: '#247a55', border: '#a0e0c6' },
};

const toTrangThaiKhacKey = (valueOrKey) => {
    const opt =
        TRANG_THAI_KHAC_OPTIONS.find(o => o.value === valueOrKey || o.key === valueOrKey) ||
        TRANG_THAI_KHAC_OPTIONS.find(o => o.value === Number(valueOrKey));
    return opt ? opt.key : null;
};

const getStatusStyleNhiemVuKhac = (status) => {
    const key = toTrangThaiKhacKey(status);
    const style = key ? STATUS_COLOR_MAP_KHAC[key] : null;

    if (!style) {
        return {
            backgroundColor: '#e9ecef',
            border: '1px solid #ced4da',
            color: '#495057',
            borderRadius: '12px',
            padding: '2px 8px',
            fontSize: '0.85rem',
            display: 'inline-block',
            minWidth: '90px',
            textAlign: 'center',
        };
    }

    return {
        backgroundColor: style.bg,
        border: `1px solid ${style.border}`,
        color: style.text,
        borderRadius: '12px',
        padding: '2px 8px',
        fontSize: '0.85rem',
        display: 'inline-block',
        minWidth: '90px',
        textAlign: 'center',
    };
};

// helper format ngày
const formatDateCell = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString();
};

const clampPercent = (v) => {
    const n = Number(v);
    if (!Number.isFinite(n)) return 0;
    return Math.max(0, Math.min(100, Math.round(n)));
};

const renderTienDoCell = (value) => {
    if (value === undefined || value === null) {
        return <span className="text-muted"></span>;
    }

    const p = clampPercent(value);
    return <span>{p}%</span>;
};

// định nghĩa loại file cho preview
const PREVIEW_EXTS = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'pdf']);
const getExt = (nameOrUrl = '') => {
    const s = (nameOrUrl || '').toString().split('?')[0];
    const parts = s.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
};
const isPreviewable = (nameOrUrl) => PREVIEW_EXTS.has(getExt(nameOrUrl));

const NhiemVuKhac = () => {
    const isMounted = useRef(true);
    useEffect(() => () => { isMounted.current = false; }, []);

    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const listLoading = useSelector(state => state.nhiemVuKhac.loadingPaging);


    const valueSearch = useSelector(state => state.search.valueSearch);
    const totalNhiemVuKhac = useSelector(state => state.nhiemVuKhac.totalNhiemVuKhac);
    const listNhiemVuKhac = useSelector(state => state.nhiemVuKhac.listNhiemVuKhac);
    const listNhanVien = useSelector(state => state.nhanVien.list || []);
    const filesByNhiemVuKhacId = useSelector(state => state.nhiemVuKhac.filesByNhiemVuKhacId || {});

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [userNameMap, setUserNameMap] = useState({});

    // ===== CURRENT USER (CỦA TÔI) =====
    const [accountId, setAccountId] = useState(null);
    const [myNguoiDungId, setMyNguoiDungId] = useState(null);
    const [myNguoiDungName, setMyNguoiDungName] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const didInitMineRef = useRef(false);

    // filter states (Hạn chót)
    const [dates, setDates] = useState({ startDate: null, endDate: null });

    // filter states (Ngày giao) - MỚI
    const [ngayGiaoDates, setNgayGiaoDates] = useState({ startDate: null, endDate: null });

    const [filterMucDo, setFilterMucDo] = useState('');
    const [filterNhanVien, setFilterNhanVien] = useState('');
    const [selectedNhanVienOption, setSelectedNhanVienOption] = useState(null);

    // filter trạng thái - MỚI
    const [filterStatus, setFilterStatus] = useState('');
    const [selectedStatusOption, setSelectedStatusOption] = useState(null);

    // filter người giao (NguoiDungId) - MỚI
    const [filterNguoiDungId, setFilterNguoiDungId] = useState('');
    const [selectedNguoiDungOption, setSelectedNguoiDungOption] = useState(null);

    // ==========================
    // Người giao autocomplete (GIỐNG HoTro)
    // ==========================
    const [nguoiDungOptions, setNguoiDungOptions] = useState([]);
    const [searchNguoiDung, setSearchNguoiDung] = useState('');
    const nguoiDungTimeoutRef = useRef(null);
    const allNguoiDungCacheRef = useRef([]);
    const quickSearchTimeoutRef = useRef(null);


    // Fetch suggestions from API and normalize nested responses
    const fetchNguoiDungOptions = async (keyword) => {
        try {
            const model = { Keyword: keyword || '', PageIndex: 1, PageSize: 20 };
            const res = await Get(NGUOIDUNG_API.GET_ALL, null, model);

            const findArray = (obj) => {
                if (!obj) return [];
                if (Array.isArray(obj)) return obj;
                if (typeof obj !== 'object') return [];
                for (const k of Object.keys(obj)) {
                    const v = obj[k];
                    if (Array.isArray(v)) return v;
                    if (v && typeof v === 'object') {
                        const nested = findArray(v);
                        if (nested && nested.length > 0) return nested;
                    }
                }
                return [];
            };

            const items = findArray(res) || [];
            const options = items.map(u => ({
                value: String(u.id || u.nguoiDungId || u.accountId || u.userId),
                label: u.hoTen || u.fullName || u.name || u.ten || u.displayName || String(u.id || u.nguoiDungId)
            }));

            allNguoiDungCacheRef.current = options;
            setNguoiDungOptions(options);
        } catch (err) {
            setNguoiDungOptions([]);
        }
    };

    const handleNguoiDungSelectInputChange = (input, meta) => {
        if (meta?.action !== 'input-change') return input;

        setSearchNguoiDung(input);

        // không có input -> đổ từ cache
        if (!input) {
            if (allNguoiDungCacheRef.current.length > 0) {
                setNguoiDungOptions([...allNguoiDungCacheRef.current]);
                return input;
            }
        }

        // có input -> filter local trước
        if (input && allNguoiDungCacheRef.current.length > 0) {
            const local = allNguoiDungCacheRef.current.filter(o =>
                (o.label || '').toLowerCase().includes(input.toLowerCase())
            );
            if (local.length > 0) {
                setNguoiDungOptions(local);
                return input;
            }
        }

        // debounce fetch
        if (nguoiDungTimeoutRef.current) clearTimeout(nguoiDungTimeoutRef.current);
        nguoiDungTimeoutRef.current = setTimeout(() => {
            fetchNguoiDungOptions(input || '');
        }, 250);

        return input;
    };

    const handleNguoiDungMenuOpen = () => {
        if (allNguoiDungCacheRef.current.length > 0) {
            setNguoiDungOptions([...allNguoiDungCacheRef.current]);
            return;
        }
        fetchNguoiDungOptions('');
    };


    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

    // files modal state
    const [filesModalOpen, setFilesModalOpen] = useState(false);
    const [filesModalNhiemVuId, setFilesModalNhiemVuId] = useState(null);

    const getTenNhanVien = (id) => {
        const nv = listNhanVien.find(y => String(y.id) === String(id));
        return nv ? (nv.name || nv.hoTen || nv.tenNhanVien || nv.ten) : 'Không rõ';
    };

    const getNhanVienLabel = (nv) =>
        nv?.tenNhanVien || nv?.hoTen || nv?.name || nv?.ten || nv?.displayName || '';

    // options for selects
    const mucDoOptions = useMemo(
        () => MUC_DO_UU_TIEN.map(m => ({ value: String(m.value), label: m.label })),
        []
    );

    const nhanVienOptions = useMemo(
        () => listNhanVien.map(nv => ({
            value: String(nv.id),
            label: nv.name || nv.hoTen || nv.tenNhanVien || nv.ten || String(nv.id)
        })),
        [listNhanVien]
    );

    // Trạng thái options - MỚI
    const statusOptions = useMemo(() => {
        return (TRANG_THAI_KHAC_OPTIONS || []).map(o => ({
            value: String(o.value),
            label: o.label || o.text || o.name || mapTrangThaiKhacLabel(o.value) || String(o.value)
        }));
    }, []);

    // Người giao options - MỚI (lấy từ userNameMap + list hiện có)
    //const nguoiDungOptions = useMemo(() => {
    //    const ids = new Set();

    //    // từ list hiện có
    //    (listNhiemVuKhac || []).forEach(x => {
    //        if (x?.nguoiDungId) ids.add(String(x.nguoiDungId));
    //    });

    //    // từ cache userNameMap
    //    Object.keys(userNameMap || {}).forEach(k => {
    //        if (k) ids.add(String(k));
    //    });

    //    return Array.from(ids).map(id => ({
    //        value: String(id),
    //        label: userNameMap?.[id] || id
    //    }));
    //}, [listNhiemVuKhac, userNameMap]);

    const selectStyles = {
        control: (provided) => ({ ...provided, minHeight: 30, height: 30, fontSize: 13 }),
        valueContainer: (provided) => ({ ...provided, padding: '0 8px' }),
        indicatorsContainer: (provided) => ({ ...provided, height: 30 }),
        input: (provided) => ({ ...provided, margin: 0, padding: 0 }),
        option: (provided) => ({ ...provided, fontSize: 13 })
    };

    const TABLE_HEADER_FOOTER_CELL_STYLE = {
        textAlign: 'center',
        verticalAlign: 'middle'
    };

    const fetchData = useCallback(
        async (Page, Size, Search, Filters = {}, updateUrl = true) => {
            const model = { Keyword: Search, PageIndex: Page, PageSize: Size };

            // Hạn chót: From/To
            if (Filters.from) model.From = moment(Filters.from).format('YYYY-MM-DD');
            if (Filters.to) model.To = moment(Filters.to).format('YYYY-MM-DD');

            // Ngày giao: NgayGiaoFrom/NgayGiaoTo (MỚI)
            if (Filters.ngayGiaoFrom) model.NgayGiaoFrom = moment(Filters.ngayGiaoFrom).format('YYYY-MM-DD');
            if (Filters.ngayGiaoTo) model.NgayGiaoTo = moment(Filters.ngayGiaoTo).format('YYYY-MM-DD');

            if (Filters.mucDo !== undefined && Filters.mucDo !== '') model.MucDo = Filters.mucDo;
            if (Filters.nhanVienId) model.NhanVienId = Filters.nhanVienId;

            // Status (MỚI)
            if (Filters.status !== undefined && Filters.status !== null && Filters.status !== '') {
                model.Status = Filters.status;
            }

            // NguoiDungId (MỚI)
            if (Filters.nguoiDungId) model.NguoiDungId = Filters.nguoiDungId;

            await dispatch(nhiemVuKhacPagingAction(model));
            if (listNhanVien.length === 0) dispatch(nhanVienGetAllAction());

            if (updateUrl) {
                const params = { page: Page, size: Size, search: Search };

                // Hạn chót
                if (Filters.from) params.from = moment(Filters.from).format('YYYY-MM-DD');
                if (Filters.to) params.to = moment(Filters.to).format('YYYY-MM-DD');

                // Ngày giao
                if (Filters.ngayGiaoFrom) params.ngaygiaofrom = moment(Filters.ngayGiaoFrom).format('YYYY-MM-DD');
                if (Filters.ngayGiaoTo) params.ngaygiaoto = moment(Filters.ngayGiaoTo).format('YYYY-MM-DD');

                if (Filters.mucDo !== undefined && Filters.mucDo !== '') params.mucdo = Filters.mucDo;
                if (Filters.nhanVienId) params.nhanvien = Filters.nhanVienId;

                if (Filters.status !== undefined && Filters.status !== null && Filters.status !== '') {
                    params.status = Filters.status;
                }
                if (Filters.nguoiDungId) params.nguoidung = Filters.nguoiDungId;

                history.replace(createUrlWithParam(URI_INTERNAL.NHIEMVUKHAC_PATH, params));
            }
        },
        [dispatch, history, listNhanVien.length, listNhanVien]
    );

    // build userNameMap
    useEffect(() => {
        if (!listNhiemVuKhac || listNhiemVuKhac.length === 0) return;
        const ids = Array.from(new Set(listNhiemVuKhac.map(x => x.nguoiDungId).filter(Boolean)));
        const toFetch = ids.filter(id => !userNameMap[id]);
        if (toFetch.length === 0) return;

        Promise.all(
            toFetch.map(async (id) => {
                try {
                    const res = await dispatch(getNguoiDungById(id));
                    let item = res?.payload?.data || res?.payload || res;
                    if (Array.isArray(item)) item = item[0] || null;
                    const name = item?.hoTen || item?.fullName || item?.name || item?.ten;
                    if (name) return { id, name };
                } catch { }

                try {
                    const res2 = await dispatch(getNguoiDungByAccountId(id));
                    let item2 = res2?.payload?.data || res2?.payload || res2;
                    if (Array.isArray(item2)) item2 = item2[0] || null;
                    const name2 = item2?.hoTen || item2?.fullName || item2?.name;
                    return { id, name: name2 || id };
                } catch { return { id, name: id }; }
            })
        ).then(results => {
            if (!isMounted.current) return;
            setUserNameMap(prev => {
                const next = { ...prev };
                results.forEach(r => { if (r) next[r.id] = r.name; });
                return next;
            });
        });
    }, [listNhiemVuKhac, dispatch, userNameMap]);


    // Đồng bộ label cho Select options khi đã có dữ liệu mapping
    useEffect(() => {
        if (filterNguoiDungId && !selectedNguoiDungOption) {
            const name = userNameMap[filterNguoiDungId];
            if (name) {
                setSelectedNguoiDungOption({ value: String(filterNguoiDungId), label: name });
                setSearchNguoiDung(name);
            }
        }
        if (filterNhanVien && !selectedNhanVienOption && listNhanVien.length > 0) {
            const nv = listNhanVien.find(x => String(x.id) === String(filterNhanVien));
            if (nv) {
                setSelectedNhanVienOption({ value: String(nv.id), label: getNhanVienLabel(nv) });
            }
        }
    }, [filterNguoiDungId, filterNhanVien, userNameMap, listNhanVien, selectedNguoiDungOption, selectedNhanVienOption]);


    // Get current user and detect admin-like roles, fetch myNguoiDungId
    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const user = await userManager.getUser();

                try {
                    const normalize = (s) => (s || '').toString().toLowerCase().trim();
                    let rolesArr = [];
                    const profileRoles = user?.profile?.role || user?.profile?.roles || null;
                    if (profileRoles) {
                        if (Array.isArray(profileRoles)) rolesArr = profileRoles.map(r => normalize(r));
                        else rolesArr = normalize(profileRoles).split(/[;,]/).map(r => r.trim()).filter(Boolean);
                    } else {
                        const info = getInfomationAccountFromToken();
                        const tokenRoles = info?.role || info?.roles || null;
                        if (tokenRoles) {
                            if (Array.isArray(tokenRoles)) rolesArr = tokenRoles.map(r => normalize(r));
                            else rolesArr = normalize(tokenRoles).split(/[;,]/).map(r => r.trim()).filter(Boolean);
                        }
                    }

                    const adminLike = rolesArr.includes('admin') || rolesArr.includes('manager') || rolesArr.includes('phụ trách bộ phận') || rolesArr.includes('phu trach bo phan');
                    if (mounted) setIsAdmin(Boolean(adminLike));
                } catch (e) { }

                const idFromUser = user?.profile?.sub || user?.profile?.accountId || user?.profile?.nameid || null;
                const nameFromUser = user?.profile?.name || user?.profile?.preferred_username || user?.profile?.email || null;

                if (mounted && idFromUser) {
                    setAccountId(String(idFromUser));
                    if (nameFromUser) setMyNguoiDungName(String(nameFromUser));

                    try {
                        const payload = await dispatch(getNguoiDungByAccountId(idFromUser)).unwrap();
                        let item = payload || null;
                        if (Array.isArray(item)) item = item[0] || null;
                        if (item && item.data) item = item.data;
                        if (Array.isArray(item)) item = item[0] || null;
                        if (item && item.data) item = item.data;

                        const foundId = item?.id || item?.nguoiDungId;
                        const foundName = item?.hoTen || item?.fullName;

                        if (mounted && foundId) setMyNguoiDungId(String(foundId));
                        if (mounted && foundName) setMyNguoiDungName(String(foundName));

                        if (mounted && foundId && foundName) {
                            setUserNameMap(prev => ({ ...prev, [String(foundId)]: foundName }));
                        }
                    } catch { }
                }
            } catch (e) { }
        })();

        return () => { mounted = false; };
    }, [dispatch]);


    // Auto-initialize view based on URL or roles
    useEffect(() => {
        if (didInitMineRef.current) return;

        const sp = new URLSearchParams(location.search || '');
        const hasParams = sp.has('page') || sp.has('size') || sp.has('search') ||
                          sp.has('nguoidung') || sp.has('status') || sp.has('nhanvien') ||
                          sp.has('mucdo') || sp.has('from') || sp.has('to') ||
                          sp.has('ngaygiaofrom') || sp.has('ngaygiaoto');

        if (hasParams) {
            didInitMineRef.current = true;
            
            // 1. Đồng bộ state từ URL
            const p = parseInt(sp.get('page'), 10) || 1;
            const s = parseInt(sp.get('size'), 10) || 20;
            const searchVal = sp.get('search') || '';
            
            const ndId = sp.get('nguoidung') || '';
            const st = sp.get('status') || '';
            const nvId = sp.get('nhanvien') || '';
            const md = sp.get('mucdo') || '';
            
            const dFrom = sp.get('from');
            const dTo = sp.get('to');
            const ngFrom = sp.get('ngaygiaofrom');
            const ngTo = sp.get('ngaygiaoto');

            setPage(p);
            setPageSize(s);
            setSearch(searchVal);
            setFilterNguoiDungId(ndId);
            setFilterStatus(st);
            setFilterNhanVien(nvId);
            setFilterMucDo(md);
            
            if (dFrom || dTo) setDates({ startDate: dFrom ? moment(dFrom) : null, endDate: dTo ? moment(dTo) : null });
            if (ngFrom || ngTo) setNgayGiaoDates({ startDate: ngFrom ? moment(ngFrom) : null, endDate: ngTo ? moment(ngTo) : null });

            // Cập nhật selected options cho react-select (nếu có thể)
            if (ndId) {
                // Sẽ được cập nhật sau bởi useEffect fetch tên người dùng
            }
            if (st) {
                const opt = (TRANG_THAI_KHAC_OPTIONS || []).find(o => String(o.value) === String(st));
                if (opt) setSelectedStatusOption({ value: String(opt.value), label: opt.label });
            }
            if (nvId && listNhanVien.length > 0) {
                const nv = listNhanVien.find(x => String(x.id) === String(nvId));
                if (nv) {
                    setSelectedNhanVienOption({ value: String(nv.id), label: getNhanVienLabel(nv) });
                    setFilterNhanVien(String(nv.id));
                }
            }

            // 2. Fetch dữ liệu
            fetchData(p, s, searchVal, {
                from: dFrom ? new Date(dFrom) : null,
                to: dTo ? new Date(dTo) : null,
                ngayGiaoFrom: ngFrom ? new Date(ngFrom) : null,
                ngayGiaoTo: ngTo ? new Date(ngTo) : null,
                mucDo: md,
                nhanVienId: nvId,
                status: st,
                nguoiDungId: ndId
            }, false); // updateUrl = false để tránh ghi đè URL khi đang mount
            
            return;
        }

        // Nếu không có param, xử lý theo vai trò
        if (isAdmin) {
            didInitMineRef.current = true;
            onShowAll();
            return;
        }

        if (myNguoiDungId) {
            didInitMineRef.current = true;
            onShowMine();
            return;
        }
    }, [isAdmin, myNguoiDungId, location.search, listNhanVien]);

    const changePage = (number) => {
        setPage(number);
        fetchData(number, pageSize, search, {
            from: dates.startDate ? dates.startDate.toDate() : null,
            to: dates.endDate ? dates.endDate.toDate() : null,

            ngayGiaoFrom: ngayGiaoDates.startDate ? ngayGiaoDates.startDate.toDate() : null,
            ngayGiaoTo: ngayGiaoDates.endDate ? ngayGiaoDates.endDate.toDate() : null,

            mucDo: filterMucDo !== '' ? (isNaN(Number(filterMucDo)) ? filterMucDo : Number(filterMucDo)) : '',
            nhanVienId: filterNhanVien,

            status: filterStatus !== '' ? (isNaN(Number(filterStatus)) ? filterStatus : Number(filterStatus)) : '',
            nguoiDungId: filterNguoiDungId
        }, true);
    };

    const onChangeShowNumber = (e) => {
        const newSize = parseInt(e.target.value, 10);
        setPageSize(newSize);
        fetchData(page, newSize, search, {
            from: dates.startDate ? dates.startDate.toDate() : null,
            to: dates.endDate ? dates.endDate.toDate() : null,

            ngayGiaoFrom: ngayGiaoDates.startDate ? ngayGiaoDates.startDate.toDate() : null,
            ngayGiaoTo: ngayGiaoDates.endDate ? ngayGiaoDates.endDate.toDate() : null,

            mucDo: filterMucDo !== '' ? (isNaN(Number(filterMucDo)) ? filterMucDo : Number(filterMucDo)) : '',
            nhanVienId: filterNhanVien,

            status: filterStatus !== '' ? (isNaN(Number(filterStatus)) ? filterStatus : Number(filterStatus)) : '',
            nguoiDungId: filterNguoiDungId
        }, true);
    };

    const onApplyFilters = () => {
        const modelFilters = {
            from: dates.startDate ? dates.startDate.toDate() : null,
            to: dates.endDate ? dates.endDate.toDate() : null,

            ngayGiaoFrom: ngayGiaoDates.startDate ? ngayGiaoDates.startDate.toDate() : null,
            ngayGiaoTo: ngayGiaoDates.endDate ? ngayGiaoDates.endDate.toDate() : null,

            mucDo: filterMucDo !== '' ? (isNaN(Number(filterMucDo)) ? filterMucDo : Number(filterMucDo)) : '',
            nhanVienId: filterNhanVien,

            status: filterStatus !== '' ? (isNaN(Number(filterStatus)) ? filterStatus : Number(filterStatus)) : '',
            nguoiDungId: filterNguoiDungId
        };
        setPage(1);
        fetchData(1, pageSize, search, modelFilters, true);
    };

    const onResetFilters = () => {
        setDates({ startDate: null, endDate: null });
        setNgayGiaoDates({ startDate: null, endDate: null });

        setFilterMucDo('');
        setFilterNhanVien('');
        setSelectedNhanVienOption(null);

        setFilterStatus('');
        setSelectedStatusOption(null);

        setFilterNguoiDungId('');
        setSelectedNguoiDungOption(null);

        setPage(1);
        fetchData(1, pageSize, search, {}, true);
    };

    const onShowMine = () => {
        const myId = myNguoiDungId;
        if (!myId) {
            toast.warn('Chưa lấy được NguoiDungId của tài khoản đăng nhập.');
            return;
        }

        setFilterNguoiDungId(String(myId));
        setSelectedNguoiDungOption({ value: String(myId), label: myNguoiDungName || 'Của tôi' });
        setSearchNguoiDung(myNguoiDungName || '');

        setPage(1);
        fetchData(1, pageSize, search, {
            ...buildCurrentFilters(),
            nguoiDungId: String(myId)
        }, true);
    };

    const onShowAll = () => {
        setFilterNguoiDungId('');
        setSelectedNguoiDungOption(null);
        setSearchNguoiDung('');

        setPage(1);
        // Ép buộc nguoiDungId trống ngay lập tức để tránh state cũ
        fetchData(1, pageSize, search, {
            ...buildCurrentFilters(),
            nguoiDungId: ''
        }, true);
    };

    // handle select nhan vien
    const handleSelectNhanVien = (opt) => {
        if (!opt) {
            setSelectedNhanVienOption(null);
            setFilterNhanVien('');
            return;
        }
        setSelectedNhanVienOption({ value: String(opt.value), label: opt.label });
        setFilterNhanVien(String(opt.value));
    };

    // handle select status - MỚI
    const handleSelectStatus = (opt) => {
        if (!opt) {
            setSelectedStatusOption(null);
            setFilterStatus('');
            return;
        }
        setSelectedStatusOption({ value: String(opt.value), label: opt.label });
        setFilterStatus(String(opt.value));
    };

    // handle select nguoi dung - MỚI
    const handleSelectNguoiDung = (opt) => {
        if (!opt) {
            setSelectedNguoiDungOption(null);
            setFilterNguoiDungId('');
            setSearchNguoiDung('');
            return;
        }
        setSelectedNguoiDungOption({ value: String(opt.value), label: opt.label });
        setFilterNguoiDungId(String(opt.value));
        setSearchNguoiDung(opt.label || '');
    };


    const makeFileUrl = (fileUrl) => (
        fileUrl && fileUrl.startsWith('http') ? fileUrl : `${BaseGatewayImage}${fileUrl || ''}`
    );

    const getFileExt = (f) => {
        const raw = (f?.name || f?.fileName || f?.fileUrl || '').toString().toLowerCase();
        const clean = raw.split('?')[0].split('#')[0];
        const i = clean.lastIndexOf('.');
        return i >= 0 ? clean.slice(i + 1) : '';
    };

    const INLINE_PREVIEW_EXTS = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'pdf']);
    const canInlinePreview = (f) => INLINE_PREVIEW_EXTS.has(getFileExt(f));

    const handleDownloadNhiemVuFile = async (f) => {
        try {
            const urls = [NHIEMVUKHAC_API.DOWNLOAD_FILE(f.id || f.Id)];
            await downloadFileByUrls(urls, f.name || f.fileName || f.Name || 'tep-dinh-kem');
        } catch (e) {
            console.error('Download error:', e);
            toast.error('Không thể tải tệp. Vui lòng thử lại hoặc liên hệ quản trị.');
        }
    };

    const openFilesModal = async (nhiemVuId) => {
        setFilesModalNhiemVuId(nhiemVuId);
        setFilesModalOpen(true);
        try {
            await dispatch(nhiemVuKhacGetFilesAction(nhiemVuId));
        } catch (_) { }
    };

    const closeFilesModal = () => {
        setFilesModalOpen(false);
        setFilesModalNhiemVuId(null);
    };

    useEffect(() => {
        if (!listNhiemVuKhac || listNhiemVuKhac.length === 0) return;
        listNhiemVuKhac.forEach(item => {
            const id = item.id;
            if (!id) return;
            if (!filesByNhiemVuKhacId[id]) {
                dispatch(nhiemVuKhacGetFilesAction(id));
            }
        });
    }, [listNhiemVuKhac, filesByNhiemVuKhacId, dispatch]);

    const openOrDownloadFileFromList = async (fileDto) => {
        const id = fileDto.id || fileDto.Id;
        const name = fileDto.name || fileDto.Name || 'download';
        const relative = fileDto.fileUrl || fileDto.FileUrl || '';
        const directUrl = `${BaseGatewayImage}${relative}`;

        if (isPreviewable(name) || isPreviewable(relative)) {
            window.open(directUrl, '_blank', 'noopener,noreferrer');
            return;
        }

        const downloadUrl = NHIEMVUKHAC_API.DOWNLOAD_FILE(id);
        await downloadFileByUrls([downloadUrl], name);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (!idWantDelete) return;

        try {
            await dispatch(deleteNhiemVuKhacAction(idWantDelete));

            toast.success(messageToast.messageToastDeleteSuccess);

            // Tính toán lại tổng số bản ghi sau khi xóa
            const newTotal = Math.max(0, (totalNhiemVuKhac || 0) - 1);
            const maxPage = Math.max(1, Math.ceil(newTotal / pageSize));
            const newPage = page > maxPage ? maxPage : page;

            fetchData(newPage, pageSize, search, {
                from: dates.startDate ? dates.startDate.toDate() : null,
                to: dates.endDate ? dates.endDate.toDate() : null,

                ngayGiaoFrom: ngayGiaoDates.startDate ? ngayGiaoDates.startDate.toDate() : null,
                ngayGiaoTo: ngayGiaoDates.endDate ? ngayGiaoDates.endDate.toDate() : null,

                mucDo: filterMucDo !== '' ? (isNaN(Number(filterMucDo)) ? filterMucDo : Number(filterMucDo)) : '',
                nhanVienId: filterNhanVien,

                status: filterStatus !== '' ? (isNaN(Number(filterStatus)) ? filterStatus : Number(filterStatus)) : '',
                nguoiDungId: filterNguoiDungId
            }, true);

            setOpenConfirmDeleteModal(false);
            setIdWantDelete('');
        } catch (err) {
            const errMsg = err?.message || messageToast.messageToastTryCatch;
            toast.error(errMsg);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const buildCurrentFilters = () => ({
        from: dates.startDate ? dates.startDate.toDate() : null,
        to: dates.endDate ? dates.endDate.toDate() : null,

        ngayGiaoFrom: ngayGiaoDates.startDate ? ngayGiaoDates.startDate.toDate() : null,
        ngayGiaoTo: ngayGiaoDates.endDate ? ngayGiaoDates.endDate.toDate() : null,

        mucDo: filterMucDo !== '' ? (isNaN(Number(filterMucDo)) ? filterMucDo : Number(filterMucDo)) : '',
        nhanVienId: filterNhanVien,

        status: filterStatus !== '' ? (isNaN(Number(filterStatus)) ? filterStatus : Number(filterStatus)) : '',
        nguoiDungId: filterNguoiDungId
    });

    const handleQuickSearchChange = (e) => {
        const v = e.target.value || '';
        setSearch(v);

        if (quickSearchTimeoutRef.current) clearTimeout(quickSearchTimeoutRef.current);

        quickSearchTimeoutRef.current = setTimeout(() => {
            setPage(1);
            fetchData(1, pageSize, v, buildCurrentFilters(), true);
        }, 350);
    };

    const clearQuickSearch = () => {
        if (quickSearchTimeoutRef.current) clearTimeout(quickSearchTimeoutRef.current);

        setSearch('');
        setPage(1);
        fetchData(1, pageSize, '', buildCurrentFilters(), true);
    };




    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Danh sách Nhiệm vụ</h3>
                        </div>

                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-2">
                                <form className="form-inline">
                                    <label className="mr-2">Hiển thị :</label>
                                    <select className="form-control" value={pageSize} onChange={onChangeShowNumber}>
                                        {objectShowNumber.map((item, key) => (
                                            <option key={key} value={item.value}>{item.text}</option>
                                        ))}
                                    </select>
                                </form>

                                <div className="d-flex align-items-center">
                                    <NavLink className="nav-link-reject nav-link" to={URI_INTERNAL.NHIEMVUKHAC_CREATE_PATH}>
                                        <button type="button" className="btn btn-info">Thêm mới</button>
                                    </NavLink>
                                </div>
                            </div>

                            {/* Filters UI */}
                            <div className="mb-2">
                                <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
                                    {/* Search giống HoTro/YeuCau */}
                                    <div className="input-group input-group-sm" style={{ width: 300, minWidth: 220 }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Tìm theo nội dung..."
                                            value={search}
                                            onChange={handleQuickSearchChange}
                                        />
                                        {search ? (
                                            <div className="input-group-append">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary"
                                                    onClick={clearQuickSearch}
                                                    title="Xóa tìm kiếm"
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        ) : null}
                                    </div>

                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => setShowAdvancedFilters(true)}
                                    >
                                        Lọc nâng cao
                                    </button>

                                    <button
                                        type="button"
                                        className={`btn btn-sm mr-2 ${myNguoiDungId && String(filterNguoiDungId) === String(myNguoiDungId) ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={onShowMine}
                                    >
                                        Của tôi
                                    </button>

                                    <button
                                        type="button"
                                        className={`btn btn-sm mr-2 ${!filterNguoiDungId ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={onShowAll}
                                    >
                                        Tất cả
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-sm btn-light ml-2"
                                        title="Xóa lọc"
                                        onClick={() => { onResetFilters(); }}
                                    >
                                        Xóa lọc
                                    </button>
                                </div>
                            </div>


                            {showAdvancedFilters && (
                                <div className="modal show" style={{ display: 'block', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2000 }} tabIndex="-1" role="dialog">
                                    <div className="modal-dialog modal-lg" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">Lọc nâng cao</h5>
                                                <button type="button" className="close" onClick={() => setShowAdvancedFilters(false)} aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form className="form-inline">
                                                    {/* Hạn chót */}
                                                    <label className="mr-2">Hạn chót:</label>
                                                    <div style={{ width: 220 }} className="mr-2">
                                                        <DateRangePicker
                                                            onApply={(event, picker) => {
                                                                setDates({ startDate: picker.startDate, endDate: picker.endDate });
                                                                picker.element.val(`${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`);
                                                            }}
                                                            onCancel={(event, picker) => {
                                                                setDates({ startDate: null, endDate: null });
                                                                picker.element.val('');
                                                            }}
                                                            initialSettings={{
                                                                autoUpdateInput: false,
                                                                locale: { format: 'DD/MM/YYYY', cancelLabel: 'Xóa', applyLabel: 'Chọn' },
                                                                linkedCalendars: false,
                                                                showDropdowns: true
                                                            }}
                                                        >
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                defaultValue={
                                                                    dates.startDate && dates.endDate
                                                                        ? `${dates.startDate.format('DD/MM/YYYY')} - ${dates.endDate.format('DD/MM/YYYY')}`
                                                                        : ''
                                                                }
                                                                onChange={(e) => { if (e.target.value.length === 0) setDates({ startDate: null, endDate: null }); }}
                                                            />
                                                        </DateRangePicker>
                                                    </div>

                                                    {/* Ngày giao - MỚI */}
                                                    <label className="mr-2">Ngày giao:</label>
                                                    <div style={{ width: 220 }} className="mr-2">
                                                        <DateRangePicker
                                                            onApply={(event, picker) => {
                                                                setNgayGiaoDates({ startDate: picker.startDate, endDate: picker.endDate });
                                                                picker.element.val(`${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`);
                                                            }}
                                                            onCancel={(event, picker) => {
                                                                setNgayGiaoDates({ startDate: null, endDate: null });
                                                                picker.element.val('');
                                                            }}
                                                            initialSettings={{
                                                                autoUpdateInput: false,
                                                                locale: { format: 'DD/MM/YYYY', cancelLabel: 'Xóa', applyLabel: 'Chọn' },
                                                                linkedCalendars: false,
                                                                showDropdowns: true
                                                            }}
                                                        >
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                defaultValue={
                                                                    ngayGiaoDates.startDate && ngayGiaoDates.endDate
                                                                        ? `${ngayGiaoDates.startDate.format('DD/MM/YYYY')} - ${ngayGiaoDates.endDate.format('DD/MM/YYYY')}`
                                                                        : ''
                                                                }
                                                                onChange={(e) => { if (e.target.value.length === 0) setNgayGiaoDates({ startDate: null, endDate: null }); }}
                                                            />
                                                        </DateRangePicker>
                                                    </div>

                                                    <div className="w-100 my-2" />

                                                    {/* Mức độ */}
                                                    <label className="mr-2">Mức độ:</label>
                                                    <div style={{ width: 160 }} className="mr-2">
                                                        <Select
                                                            styles={selectStyles}
                                                            options={mucDoOptions}
                                                            value={mucDoOptions.find(o => String(o.value) === String(filterMucDo)) || null}
                                                            onChange={(opt) => setFilterMucDo(opt ? String(opt.value) : '')}
                                                            isClearable
                                                            placeholder="Tất cả"
                                                            classNamePrefix="react-select-sm"
                                                        />
                                                    </div>

                                                    {/* Người nhận */}
                                                    <label className="mr-2">Người nhận:</label>
                                                    <div style={{ width: 260 }} className="mr-2">
                                                        <Select
                                                            styles={selectStyles}
                                                            options={nhanVienOptions}
                                                            value={selectedNhanVienOption ? { value: String(selectedNhanVienOption.value), label: selectedNhanVienOption.label } : null}
                                                            onChange={(opt) => handleSelectNhanVien(opt)}
                                                            isClearable
                                                            placeholder="Tìm kiếm nhân viên"
                                                            classNamePrefix="react-select-sm"
                                                        />
                                                    </div>

                                                    <div className="w-100 my-2" />

                                                    {/* Người giao - MỚI */}
                                                    <label className="mr-2">Người giao:</label>
                                                    <div style={{ width: 260 }} className="mr-2">
                                                        <Select
                                                            styles={selectStyles}
                                                            options={nguoiDungOptions}
                                                            value={
                                                                selectedNguoiDungOption
                                                                    ? { value: String(selectedNguoiDungOption.value), label: selectedNguoiDungOption.label }
                                                                    : null
                                                            }
                                                            onChange={(opt) => handleSelectNguoiDung(opt)}
                                                            onInputChange={handleNguoiDungSelectInputChange}
                                                            onMenuOpen={handleNguoiDungMenuOpen}
                                                            isClearable
                                                            placeholder="Chọn người giao"
                                                            classNamePrefix="react-select-sm"
                                                        />

                                                    </div>

                                                    {/* Trạng thái - MỚI */}
                                                    <label className="mr-2">Trạng thái:</label>
                                                    <div style={{ width: 220 }} className="mr-2">
                                                        <Select
                                                            styles={selectStyles}
                                                            options={statusOptions}
                                                            value={selectedStatusOption ? { value: String(selectedStatusOption.value), label: selectedStatusOption.label } : null}
                                                            onChange={(opt) => handleSelectStatus(opt)}
                                                            isClearable
                                                            placeholder="Tất cả"
                                                            classNamePrefix="react-select-sm"
                                                        />
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-primary btn-sm mr-2" onClick={() => { onApplyFilters(); setShowAdvancedFilters(false); }}>Áp dụng</button>
                                                <button type="button" className="btn btn-secondary btn-sm" onClick={() => { onResetFilters(); setShowAdvancedFilters(false); }}>Xóa lọc</button>
                                                <button type="button" className="btn btn-light btn-sm" onClick={() => setShowAdvancedFilters(false)}>Đóng</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="project-table-wrap position-relative">
                                {listLoading && (
                                    <div
                                        className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                                        style={{ top: 0, left: 0, background: 'rgba(255,255,255,0.65)', zIndex: 10 }}
                                    >
                                        <Spinner animation="border" />
                                    </div>
                                )}
                                <Table striped bordered hover>
                                    <colgroup>
                                        <col style={{ width: '4%' }} />      {/* STT */}
                                        <col style={{ width: '10%' }} />     {/* Người yêu cầu */}
                                        <col style={{ width: '9.5%' }} />    {/* Tên nhiệm vụ */}
                                        <col style={{ width: '22%' }} />     {/* Nội dung */}
                                        <col style={{ width: '5.5%' }} />    {/* Ngày giao */}
                                        <col style={{ width: '5.5%' }} />    {/* Hạn chót */}
                                        <col style={{ width: '7.5%' }} />    {/* Hoàn thành thực */}
                                        <col style={{ width: '5%' }} />      {/* Ưu tiên */}
                                        <col style={{ width: '4.5%' }} />    {/* Tiến độ */}
                                        <col style={{ width: '5%' }} />      {/* Trạng thái */}
                                        <col style={{ width: '11%' }} />     {/* Người thực hiện */}
                                        <col style={{ width: '5.5%' }} />    {/* Tệp đính kèm */}
                                        <col style={{ width: '5%' }} />      {/* Chức năng */}
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>STT</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Người yêu cầu</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Tên nhiệm vụ</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Nội dung</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ngày giao</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Hạn chót</th>
                                            <th
                                                style={{
                                                    ...TABLE_HEADER_FOOTER_CELL_STYLE,
                                                    minWidth: '110px',
                                                    lineHeight: '1.35'
                                                }}
                                            >
                                                Hoàn thành thực tế
                                            </th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ưu tiên</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Tiến độ</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Trạng thái</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Người thực hiện</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Tệp</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Chức năng</th>
                                        </tr>
                                    </thead>

                                    {listNhiemVuKhac && listNhiemVuKhac.length > 0 ? (
                                        <tbody>
                                            {listNhiemVuKhac.map((item, index) => {
                                                const files = filesByNhiemVuKhacId[item.id] || [];
                                                return (
                                                    <tr key={item.id}>
                                                        <td>{index + 1 + (page - 1) * pageSize}</td>
                                                        <td>{userNameMap[item.nguoiDungId] || item.nguoiDungId}</td>
                                                        <td>{item.title}</td>
                                                        <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{item.moTa}</td>
                                                        <td>{formatDateCell(item.ngayGiao)}</td>
                                                        <td>{formatDateCell(item.hanChot)}</td>
                                                        <td>{formatDateCell(item.ngayKetThucThucTe)}</td>
                                                        <td>{mapMucDoUuTienLabel(item.mucDo)}</td>
                                                        <td>{renderTienDoCell(item.tienDo)}</td>
                                                        <td>
                                                            <span style={getStatusStyleNhiemVuKhac(item.status)}>
                                                                {mapTrangThaiKhacLabel(item.status)}
                                                            </span>
                                                        </td>
                                                        <td>{getTenNhanVien(item.nhanVienId)}</td>
                                                        <td>
                                                            {files.length === 0 ? (
                                                                <span className="text-muted"></span>
                                                            ) : (
                                                                <button className="btn btn-sm btn-link" onClick={() => openFilesModal(item.id)}>
                                                                    Tệp ({files.length})
                                                                </button>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            <Dropdown align="end">
                                                                <Dropdown.Toggle
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    id={`nhiemvukhac-actions-${item.id}`}
                                                                    className="d-inline-flex align-items-center justify-content-center"
                                                                >
                                                                    Thao tác
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item
                                                                        as={NavLink}
                                                                        to={createUrlWithParam(URI_INTERNAL.NHIEMVUKHAC_CONGVIEC_PATH, { nhiemVuId: item.id })}
                                                                    >
                                                                        Công việc
                                                                    </Dropdown.Item>

                                                                    <Dropdown.Item
                                                                        as={NavLink}
                                                                        to={createUrlWithParam(URI_INTERNAL.NHIEMVUKHAC_EDIT_PATH, { id: item.id })}
                                                                    >
                                                                        Sửa
                                                                    </Dropdown.Item>

                                                                    <Dropdown.Divider />

                                                                    <Dropdown.Item
                                                                        as="button"
                                                                        className="w-100 text-left text-danger"
                                                                        onClick={() => deleteAction(item.id, item.title)}
                                                                    >
                                                                        Xóa
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    ) : (
                                        <tbody>
                                            <tr className="txt-center">
                                                    <td colSpan="13">
                                                        {listLoading ? (
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <Spinner animation="border" size="sm" className="mr-2" />
                                                                <span>Đang tải dữ liệu...</span>
                                                            </div>
                                                        ) : (
                                                            'Không có dữ liệu'
                                                        )}
                                                    </td>
                                            </tr>
                                        </tbody>
                                    )}

                                    <tfoot>
                                        <tr>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>STT</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Người yêu cầu</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Tên nhiệm vụ</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Nội dung</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ngày giao</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Hạn chót</th>
                                            <th
                                                style={{
                                                    ...TABLE_HEADER_FOOTER_CELL_STYLE,
                                                    minWidth: '110px',
                                                    lineHeight: '1.35'
                                                }}
                                            >
                                                Hoàn thành thực tế
                                            </th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ưu tiên</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Tiến độ</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Trạng thái</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Người thực hiện</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Tệp</th>
                                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Chức năng</th>
                                        </tr>
                                    </tfoot>

                                </Table>
                            </div>
                            </div>

                            <div className="dataTables_paginate paging_simple_numbers">
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    innerClass="pagination pagination-sm no-margin pull-right"
                                    activePage={page}
                                    itemsCountPerPage={Number(pageSize)}
                                    totalItemsCount={totalNhiemVuKhac}
                                    pageRangeDisplayed={5}
                                    onChange={changePage}
                                />
                            </div>

                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={acceptDelete}
                                handleCancel={cancelDelete}
                                content={confirmDelMessage}
                            />

                            {/* Files modal (preview / download) */}
                            <Modal show={filesModalOpen} onHide={closeFilesModal} size="md" backdrop={false}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Danh sách tệp</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {filesModalOpen && (filesByNhiemVuKhacId[filesModalNhiemVuId] || []).length === 0 ? (
                                        <div>Không có tệp đính kèm.</div>
                                    ) : (
                                        <ul className="list-unstyled">
                                            {(filesByNhiemVuKhacId[filesModalNhiemVuId] || []).map(f => {
                                                const url = makeFileUrl(f.fileUrl || f.fileurl || f.FileUrl || f.filePath || '');
                                                const displayName = f.name || f.fileName || f.Name || 'Tệp đính kèm';
                                                const inline = canInlinePreview(f);
                                                return (
                                                    <li key={f.id || f.Id} className="d-flex align-items-center mb-2">
                                                        {inline ? (
                                                            <a href={url} target="_blank" rel="noopener noreferrer">{displayName}</a>
                                                        ) : (
                                                            <button type="button" className="btn btn-link p-0" onClick={() => handleDownloadNhiemVuFile(f)}>{displayName}</button>
                                                        )}

                                                        <button type="button" className="btn btn-link ml-2 text-muted p-0" title={`Tải ${displayName}`} onClick={() => handleDownloadNhiemVuFile(f)}>
                                                            <i className="fas fa-download" />
                                                        </button>

                                                        <small className="text-muted ml-2">{f.size ? `(${Math.round((f.size || 0) / 1024)} KB)` : ''}</small>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="btn btn-secondary" onClick={closeFilesModal}>Đóng</button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>


    );
};

export default NhiemVuKhac;
